import "./DashboardTitle.css";

function DashboardTitle({ text }) {
  return <h2 className="db__greetings">{text}</h2>;
}

export default DashboardTitle;
